import React from 'react'
import FollowBody from './FollowBody';

const FollowupTable = ({ followTable }) => {

    return (
        <div className="flex flex-col">
            <div className="overflow-x-auto mx-2">
                <div className=" pt-8 lg:py-2 inline-block min-w-full px-2  sm:px-3 lg:px-5">
                    <div className="overflow-hidden">
                        <table className="min-w-full border text-center">
                            <thead className="border-b">
                                <tr>
                                    <th scope="col" className="table_head border-r">
                                        Sno
                                    </th>
                                    <th scope="col" className="table_head border-r">
                                        Follow-Up Date
                                    </th>
                                    <th scope="col" className="table_head border-r">
                                        Follow-Up Time
                                    </th>
                                    <th scope="col" className="table_head border-r">
                                        Remarks
                                    </th>
                                    <th scope="col" className="table_head border-r">
                                        Message
                                    </th>
                                </tr>
                            </thead>
                            {followTable.length > 0 ? (followTable.map((item, index) => <FollowBody key={index} item={item} />)) : <tbody><td colSpan="100%" className='py-3 text-sm text-gray-800'>No Data Available</td></tbody>}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FollowupTable;